<template>
<main class="single-biogram" v-if="biogram">
            <div class="col-2">
                <h1>{{biogram.name}} | 
                <span v-if="biogram.birth_year">{{biogram.birth_year}}</span><span v-if="biogram.death_year">-{{biogram.death_year}}</span></h1>
                <div>
                    <div class="biogram-image">
                      <div><img :src="biogram.portrait" alt="" /></div>
                    </div>  
                    <p class="metas"><strong>METADANE</strong><br />
                    <ul :class="listClass">
                        <li v-for="(b,i) in biogram.metadata" :key="i" v-show="i" :class = "(b.hide)?'hide':'show'"><span :order="b.order" :field-id="b.field_id">{{b.field_name}}</span> <ul class="personal-metadata-values" v-html="b.value"></ul></li>
                    </ul>
                    <a v-if="this.$parent.more_meta" :class="clickMore" v-on:click="showAll">Pokaż wszystkie metadane</a>
                    <a v-if="showLessLink" class="show" v-on:click="showLess">Ukryj część metadanych</a>
                    </p>
                </div>
                <div class="text-up">
                    <p v-html="this.biogram.description" class="biogram-text"></p>
                    <p v-if="biogram.tags" class="tags">
                        <span v-for="tag in biogram.tags" :key="tag.id"><a :href="'/etykieta/' + tag.name">{{tag.name}}</a></span>
                    </p>
                    <div class="icon-links to-center">
                        <a :href="this.$parent.fbShareURL"><i class="icon-fb"></i></a>
                        <a href="javascript:void(0)" v-if="null"><i class="icon-download"></i></a>
                    </div>
                </div>
            </div>
        </main>
</template>

<script>
// components


// functions

export default {
  name: "BiogramContent",
  props: ['biogram'],
  components: {
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      listClass: "personal-metadata",
      clickMore: "show-more",
      showLessLink: false,
    };
  },
  methods: {
    showAll() {
      this.listClass = "personal-metadata show-all";
      this.clickMore = "hide-more";
      this.showLessLink = true;
    },
    showLess() {
      this.listClass = "personal-metadata";
      this.clickMore = "show-more";
      this.showLessLink = false;
    },
  },
  destroyed() {},
  mounted: function () {},
};
</script>

<style scoped>
.personal-metadata {
  list-style-type: none;
  padding: initial;
}

.personal-metadata li {
  font-size: 0.7em;
  margin-bottom: 10px;
  color: grey;
  display: block;
}

.personal-metadata li span {
  font-weight: bold;
  color: #465165;
  display: block;
}

.personal-metadata-values {
  font-size: inherit;
  list-style-type: none;
  padding-left: 0px;
}

.personal-metadata-values ul li a {
  /* color: green; */
}

.search-link {
}

.biogram-text {
}

.hide {
  display: none !important;
}

.show-more,
.show {
  font-size: 0.7em;
}

.hide-more {
  display: none;
}

.show-all li {
  display: inherit !important;
}

.tags span {
  font-size: 0.5em;
  display: inline-block;
  padding: 5px;
  background: #465165;
  margin: 5px;
  text-transform: uppercase;
}

.tags span a {
  color: #fff;
}

.tags span a:hover {
  color: #c63;
}

.biogram-image {
  text-align: center;
  padding: 2em;
  margin-bottom: 2em;
}

.biogram-image div img {
  max-width: 100%;
  background: #D9D9D9;
  background: grey;
  padding: 5em;
}

.col2 {
  align-items: flex-start;
}

.show-more, .show {
  cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/Biogram/BiogramContent.vue